<template>
    <div>
        <div :id="elementHandle" :class="['owl-carousel']">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import '@/common/css/owl.carousel.min.css';
import '@/common/css/owl.theme.default.css';
import '@/common/js/owl.carousel.min.js';

export default {

    data () {

        const random = () => ( Math.random().toString( 36 ).substring( 2, 15 ) + Math.random().toString( 36 ).substring( 2, 15 ));
        return {

            elementHandle: 'carousel_' + random()

        };

    },
    props: {

        items: {

            type: Number,
            default: 4

        },
        mouseDrag: {

            type: Boolean,
            default: true

        }

    },
    methods: {

        init () {

            $( `#${this.elementHandle}` ).owlCarousel({

                items: this.items,
                mouseDrag: this.mouseDrag,
                nav: true,
                navText: ['<span class="reo-nav-handle icon-icon_arrow-left"></span>', '<span class="reo-nav-handle icon-icon_arrow-right"></span>']

            });

        }

    }

};

</script>

<style lang="less">
body .owl-carousel .owl-nav{
    &>div{
        display: inline-block;
        padding: 10px 0;
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        padding: 0;
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 100%;
        opacity: 0.7;
        background-color: #fff;
        box-shadow: 0 0 15px 1px rgba(0, 0, 0, .1);
        span{
            font-size: 0.2rem;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        &:not(.disabled):hover{
            opacity: 1;
        }
    }
    .owl-prev{
        left: -0.7rem;
    }
    .owl-next{
        right: -0.7rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/Carousel.vue